import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import Searchbar from './searchbar';
import { Button, Glyphicon, Label } from 'react-bootstrap';
import { IListItem, IPhlebotRequest, IBaseResponse } from '@nkr/models/index';
import { GridWrapper, HeaderWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';
import {
    GridApi, GridReadyEvent, CsvExportParams, ICellRendererParams, ValueGetterParams, FirstDataRenderedEvent,
    IHeaderParams, ColDef, SortChangedEvent, ProcessCellForExportParams, CellClickedEvent, RowDataChangedEvent, GridSizeChangedEvent
} from 'ag-grid-community';
import { PhlebotStatus } from '@nkr/enums/phlebot-status';
import SortableHeaderComponent from '../admin/center/list/common/sortable-header';
import { Utility } from '@nkr/services/utility';
import Drawer from 'rc-drawer';
import ViewPhlebotRequest from './view-phlebot-request';
import Grid from './grid';

interface IProps {
    isAdminView: boolean,
    list: IPhlebotRequest[],
    types: IListItem[],
    states: IListItem[],
    onGridReady: (e: GridReadyEvent) => void,
    onSearchUpdate: (startDate: string, endDate: string, dateType: number) => void,
    reorderRequest: (requestId: number) => void,
    updateRequest: (request: IPhlebotRequest) => void,
    updateRequestToSentStatus: (requestId: number) => Promise<IBaseResponse>,
    updateRequestInViewToSent: (requestId: number) => void
}

interface IState {
    firstName: string,
    lastName: string,
    birthDate: string,
    email: string,
    alias: string,
    selectedType: number,
    selectedStatus: number,
    selectedDateType: number,
    sidebarView: {
        show: boolean,
        data: IPhlebotRequest
    },
    gridApi: GridApi
}

export default class PhlebotTracking extends React.Component<IProps, IState> {
    readonly state: IState = {
        selectedType: -1,
        selectedStatus: -1,
        selectedDateType: 0,
        firstName: '',
        lastName: '',
        birthDate: '',
        email: '',
        alias: '',
        sidebarView: {
            show: false,
            data: null
        },
        gridApi: null
    }

    container: HTMLDivElement;

    onGridReady = (e: GridReadyEvent) => {
        this.props.onGridReady(e);

        this.setState({
            gridApi: e.api
        });
    }

    onCellClicked = (e: CellClickedEvent) => {
        let request = e.data as IPhlebotRequest;

        this.setState({
            sidebarView: {
                show: true,
                data: request
            }
        });
    };

    getFilteredList = () => {
        let list = this.props.list;

        if (this.state.selectedType > -1) {
            if (this.state.selectedType == 5) {
                list = list.filter(x => x.kitType == this.state.selectedType || x.kitType == 10) //DirectStreamlinedSerology OR SerologyTracking
            } else {
                list = list.filter(x => x.kitType == this.state.selectedType)
            }
        }

        //searchNames
        if (this.state.firstName.length > 0) {
            list = list.filter(x => x.firstName != null && x.firstName.toUpperCase().indexOf(this.state.firstName.toUpperCase()) !== -1);
        }

        if (this.state.lastName.length > 0) {
            list = list.filter(x => x.lastName != null && x.lastName.toUpperCase().indexOf(this.state.lastName.toUpperCase()) !== -1)
        }

        if (this.state.email.length > 0) {
            list = list.filter(x => x.email != null && x.email.toUpperCase().indexOf(this.state.email.toUpperCase()) !== -1)
        }

        if (this.state.alias.length > 0) {
            list = list.filter(x => x.alias != null
                && x.alias.toUpperCase().indexOf(this.state.alias.toUpperCase()) !== -1)
        }

        if (this.state.selectedStatus > -1) {
            list = list.filter(x => x.status == this.state.selectedStatus)
        }

        if (this.state.selectedStatus == -2) {
            list = list.filter(x => x.status == PhlebotStatus.Pending)
        }

        if (this.state.birthDate.length > 0) {
            let value = moment(this.state.birthDate);
            if (value.isValid()) {
                if (value > moment('01/01/1900')) {
                    list = list.filter(x => x.birthDate !== null && moment(x.birthDate).isSame(moment(this.state.birthDate)))
                }
            }
        }

        return list;
    }

    getContainer = () => {
        return this.container;
    };

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    handleUpdateSearch = (startDate: string, endDate: string) => {
        this.props.onSearchUpdate(startDate, endDate, this.state.selectedDateType);
    }

    handleCsvExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'PhlebotRequests_' + "_" + moment().format("YYYY_MM_DD") + '.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();
                let colName = colDef.field;
                var result = params.value;

                if (colName == "variance" && result == -1) {
                    return "N/A"
                }

                return result;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    handleUpdateSearchCriteria = (firstName: string, lastName: string, email: string, birthDate: string, alias: string) => {
        this.setState({
            firstName,
            lastName,
            birthDate,
            email,
            alias
        });
    }

    handleUpdateKitType = (kitType: number) => {
        this.setState({
            selectedType: kitType
        });
    }

    handleUpdateStatusType = (selectedStatus: number) => {
        this.setState({
            selectedStatus: selectedStatus
        });
    }

    handleUpdateDateType = (selectedDateType: number) => {
        this.setState({
            selectedDateType: selectedDateType
        });
    }

    handleCancelView = () => {
        this.setState({
            sidebarView: {
                show: false,
                data: null
            }
        });
    };

    render = () => {
        const list = this.getFilteredList();

        return (
            <div style={{ height: '100%' }}>
                <div ref={this.saveContainer}></div>

                <h2 style={{ marginTop: 0 }}>Phlebotomy Tracking</h2>

                <Searchbar
                    selectedType={this.state.selectedType}
                    selectedStatus={this.state.selectedStatus}
                    selectedDateType={this.state.selectedDateType}
                    phlebotKitTypes={this.props.types}
                    onUpdateKitType={this.handleUpdateKitType}
                    onUpdateStatusType={this.handleUpdateStatusType}
                    onUpdateDateType={this.handleUpdateDateType}
                    onUpdateSearch={this.handleUpdateSearch}
                    onFilterSearch={this.handleUpdateSearchCriteria}
                    onCsvExport={this.handleCsvExport}
                />

                <Grid
                    data={list}
                    onGridReady={this.onGridReady}
                    onCellClicked={this.onCellClicked} />

                <div style={{ marginBottom: 5 }}>{list.length} of {this.props.list.length} records shown...</div>

                <Drawer
                    width="30vw"
                    placement="right"
                    getContainer={this.getContainer}
                    open={this.state.sidebarView.show}
                >
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ padding: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                <h3 style={{ margin: 0 }}>Phlebotomy Request</h3>
                                <Button bsStyle='link' bsSize='sm' onClick={this.handleCancelView}><Glyphicon glyph='remove' /></Button>
                            </div>

                            {this.state.sidebarView.data != null &&
                                <ViewPhlebotRequest
                                    isAdminView={this.props.isAdminView}
                                    data={this.state.sidebarView.data}
                                    types={this.props.types}
                                    states={this.props.states}
                                    onUpdate={this.props.updateRequest}
                                    onUpdateRequestToSentStatus={this.props.updateRequestToSentStatus}
                                    onUpdateRquestInViewToSent={this.props.updateRequestInViewToSent}
                                    onReorderRequest={this.props.reorderRequest}
                                />
                            }
                        </div>
                        <div className='text-center bg-info'>
                            <Button bsStyle='link' block onClick={this.handleCancelView}>Close This View</Button>
                        </div>
                    </div>
                </Drawer>
            </div>
        )
    }
}